import { GridCustomCellProps } from '@progress/kendo-react-grid';
import React from 'react';
import { CpsGridCell } from './CpsGridCell';
import { linkVerticalIcon } from '@progress/kendo-svg-icons';
import { SvgIcon } from '@progress/kendo-react-common';
import { EMPTY_VALUE } from '@cs-cms/types';

interface LinkCellProps extends GridCustomCellProps {
  title?: string;
  value?: string;
}

export const LinkCell: React.FC<LinkCellProps> = props => {
  const field = props.field || EMPTY_VALUE;
  const value = props.value || props.dataItem[field];
  const title = props.title || value?.toString();

  return (
    <CpsGridCell
      dataItem={props.dataItem}
      field={props.field}
      dataIndex={props.dataIndex}
      id={props.id}
      tdProps={props.tdProps}
      columnPosition={props.columnPosition}
      onChange={props.onChange}
      className={props.className}
      colSpan={props.colSpan}
      ariaColumnIndex={props.ariaColumnIndex}
      isSelected={props.isSelected}
      style={props.style}
      rowType={props.rowType}
      level={props.level}
      expanded={props.expanded}
      title={title}
    >
      {value ? (
        <a href={value.toString()} target="_blank" rel="noopener noreferrer" className="linkCell">
          <SvgIcon icon={linkVerticalIcon} size="small" />
          <span>Open the link</span>
        </a>
      ) : (
        <span>{EMPTY_VALUE}</span>
      )}
    </CpsGridCell>
  );
};
